<template>
  <div class="setting-auto-flow disp-scroll">
    <h2 class="title">
      <span class="mdi mdi-chart-timeline timeline"></span>
      採用フロー自動化設定
    </h2>
    <div class="field card-footer-item" v-if="user.permission===0">
      ※30日以内重複応募者は、応募者管理画面反映時の自動採用フローを非適用
      <b-field style="text-align: left;">
        <b-switch :value="recentApplicantDupflg" @input="changeToggle" type="is-primary">
          {{recentApplicantDupflg ? 'ON' : 'OFF'}}
        </b-switch>
      </b-field>
    </div>
    <div class="setting-auto-flow-table-container">
      <SettingAutoFlowTable
        :recruitList="recruitList"
        :recruitFlowActionObj="recruitFlowActionObj"
        :toggleAutoFlowModal="toggleAutoFlowModal"
        :createAutoFlow="createAutoFlow"
        :selectAutoFlowAction="selectAutoFlowAction"
        :actionTiming="actionTiming"
        :autoFlowList="autoFlowList"
        :deleteAutoFlow="deleteAutoFlow"
        :companyRecruit="companyRecruit"
        :chatbots="chatbots"
        :PCTRLLOG="CTRLLOG"
      />
    </div>
  </div>
</template>

<script>
import SettingAutoFlowTable from '@/components/molecules/tables/SettingAutoFlowTable'
import controlLogMixin from '@/mixins/controlLogMixin'
import { mapState, mapActions } from 'vuex';
import Vue from 'vue';

// イベントバスを作成
const EventBus = new Vue();

export default {
  components: {
    SettingAutoFlowTable,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    toggleAutoFlowModal: {
      type: Function,
      required: true,
      default: () => null,
    },
    createAutoFlow: {
      type: Function,
      required: true,
      default: () => null,
    },
    deleteAutoFlow: {
      type: Function,
      required: true,
      default: () => null,
    },
    recruitList: {
      type: Array,
      required: true,
      default: () => [],
    },
    recruitFlowActionObj: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
      default: () => {},
    },
    selectAutoFlowAction: {
      validator: (prop) => typeof prop === 'number' || prop === null,
      required: true,
      default: () => {},
    },
    actionTiming: {
      type: Array,
      required: true,
      default: () => [],
    },
    autoFlowList: {
      type: Array,
      required: true,
      default: () => [],
    },
    companyRecruit: {
      type: Array,
      required: true,
      default: () => [],
    },
    chatbots: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  // イベントバスのリスナー
  created() {
    EventBus.$on('open-modal', this.fetchData);
  },
  beforeDestroy() {
    EventBus.$off('open-modal', this.fetchData);
  },
  mounted() {
    const company_id = this.user.companyPK
    this.fetchRecentApplicantDupflg(company_id);
  },
  methods: {
    ...mapActions('auth', ['fetchRecentApplicantDupflg', 'omitRecentApplicantDupflg']),
    fetchData() {
      const company_id = this.user.companyPK;
      this.fetchRecentApplicantDupflg(company_id);
    },
    async changeToggle(value) {
      const company_id = this.user.companyPK;
      await this.omitRecentApplicantDupflg({ company_id, value });
    },
    // モーダルを開くメソッド
    openModal() {
      EventBus.$emit('open-modal');
    },
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'calendarEventHistory', 'emailTemplates', 'SMSTemplates', 'companyColumnSetting', 'recruitmentFlows', 'isInitCreatingRecruitmentFlow', 'calendarSettings', 'calendarBookMarks','manages','select_manages','default_manage','displaycompanyRecruit', 'mediaCooperationList', 'recentApplicantDupflg']),
  },  
}
</script>

<style lang="scss" scoped>
.setting-auto-flow {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  max-width: 800px;
  background: #fefefe;
  padding: 16px;
  z-index: 201;
  .title {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 16px;
  }
  .timeline {
    margin-right: 8px;
  }
  .setting-auto-flow-table-container {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    height: calc(100% - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/slidemenus/SettingAutoFlowMenu.vue